import React, {Component} from "react";
import PropTypes from "prop-types";

export default class Loader extends Component {
  static propTypes = {
    mod: PropTypes.string
  };
  render() {
    const {mod} = this.props;
    return (
      <div className={`lds-rolling${mod ? ` lds-rolling_${mod}` : ``}`}>
        <div />
      </div>
    );
  }
}
